"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var errorCodeConstants = {
  RESET_PASSWORD_TOKEN_NOT_VALID: 'token.not.valid',
  SERVER_INTERNAL_ERROR: 'server.internal.error',
  BFF_SERVER_INTERNAL_ERROR: 'bff.server.internal.error',
  BFF_UNKNOWN_API_ERROR: 'unknown.api.error',
  SESSION_EXPIRED: 'session.expired',
  CUSTOMER_SYNC_FAILED: 'customer.sync.failed',
  CODE_UNAUTHORIZED_TOKEN: 'code.unauthorized.token',
  ORDER_FORM_EMPTY: 'order.form.empty',
  ORDER_FORM_NOT_FOUND: 'order.form.not.found',
  HANDOVER_TOKEN_INVALID: 'handover.token.invalid',
  WEAK_PASSWORD: 'weak.password',
  ACCOUNT_IS_LOCKED: 'account.is.locked',
  USER_IS_DORMANT: 'user.is.dormant',
  GHOST_ACCOUNT_IS_LOCKED: 'ghost.account.is.locked',
  INCORRECT_LOGIN_DETAILS: 'incorrect.login.details',
  INCORRECT_EMAIL: 'incorrect.email',
  PAYPAL_UNAVAILABLE: 'paypal.service.unavailable',
  PAYPAL_SESSION_INTERNAL_ERROR: 'paypal.session.internal.error',
  POSTCODE_OUT_OF_AREA: 'postcode.out.of.area',
  CARD_PAYMENT_DETAILS_INCORRECT: 'credit.debit.card.payment.details.incorrect',
  CARD_3DSECURE_PAYMENT_DETAILS_INCORRECT: 'credit.debit.card.3dsecure.payment.details.incorrect',
  CARD_PAYMENT_NOT_AUTHORISED: 'credit.debit.card.payment.not.authorised',
  GIFT_CARD_PIN_INCORRECT: 'gift.card.pin.incorrect',
  GIFT_CARD_NOT_RECOGNISED: 'gift.card.not.recognised',
  DUPLICATE_GIFT_CARD: 'duplicate.gift.card',
  GIFT_CARD_EXPIRED: 'gift.card.expired',
  GIFT_CARD_NO_VALUE: 'gift.card.no.value',
  GIFT_CARD_SERVICE_UNAVAILABLE: 'gift.card.service.unavailable',
  UNKNOWN_GIFT_CARD_SERVICE_RESPONSE_CODE: 'unknown.gift.card.service.response.code',
  GIFT_CARD_REDEEM_FAILED: 'gift.card.redeem.failed',
  DUPLICATE_GIFT_VOUCHER: 'duplicate.gift.voucher',
  GIFT_VOUCHER_NOT_RECOGNISED: 'gift.voucher.not.recognised',
  SECURITY_CODE_INVALID: 'security.code.invalid',
  SERIAL_NUMBER_INVALID: 'serial.number.invalid',
  GIFT_VOUCHER_SERVICE_UNAVAILABLE: 'gift.voucher.service.unavailable',
  INSUFFICIENT_STOCK: 'insufficient.stock',
  CARD_PAYMENT_INVALID_FORMAT: 'credit.card.number.invalid.format',
  PROMO_CODE_NOT_APPLICABLE: 'promotion.code.not.applicable',
  PROMO_CODE_ALREADY_APPLIED: 'promotion.code.already.applied',
  // GENERATED ON CLIENT
  CLIENT_ROUTE_ERROR: 'client.route.error',
  CLIENT_CONNECTIVITY_ERROR: 'client.api.connectivity.error',
  CLIENT_UNKNOWN_TECHNICAL_ERROR: 'client.api.unknown.technical.error',
  CLIENT_PAYMENT_NOT_SELECTED: 'client.payment.not.selected',
  CLIENT_LOGIN_CREDS_INVALID_EMAIL: 'client.login.creds.invalid.email',
  CLIENT_LOGIN_CREDS_INVALID_PASSWORD: 'client.login.creds.invalid.password',
  CLIENT_FORM_VALIDATION_ERRORS: 'client.form.validation.errors',
  CLIENT_FIND_ADDRESS_ERROR: 'client.find.address.error'
};
var _default = exports["default"] = errorCodeConstants;